export {
  createCompatibilityQueryBuilder as createQueryBuilder,
} from "../../compatibility/query-builder.ts";
